import React from 'react';
import InputLabel from '@RHEnvironmental/pattern-library/dist/js/components/InputLabel';
import Button from '@RHEnvironmental/pattern-library/dist/js/components/Button';
import BodyText from '../BodyText';
import AddressMultiline from '../AddressMultiline';

const AddressInput = ({ address, onEdit }) => (
    <>
        <InputLabel show>Address</InputLabel>
        {address ? (
            <AddressMultiline address={address} />
        ) : (
            <BodyText>Not known</BodyText>
        )}
        <BodyText className="flex">
            <Button onClick={onEdit} isLink isUnderlined>
                {address ? 'Edit' : 'Add'} Address
            </Button>
        </BodyText>
    </>
);

export default AddressInput;
